import { gql } from "@apollo/client";

export const GET_SUBJECTS_AND_LEVELS = gql`
  query {
    educationLevels {
      level
      id
      yearGroups {
        id
        yearGroup
      }
    }
    subjects {
      name
      id
      subjectAndChildren {
        id
        name
      }
      feedbackFrameworks {
        id
        educationLevel {
          level
        }
      }
    }
  }
`;
export const GET_ALL_ACTIVE_SUBJECTS = gql`
  query {
    allActiveSubjects {
      name
      id
    }
    allYearGroups {
      id
      yearGroup
    }
  }
`;
export const GET_JOB_STATUS = gql`
  query ($job: ID!) {
    jobStatus(job: $job) {
      id
      status
      progress
      message
      signedUrl
      jobType {
        jobType
      }
      results {
        ... on FileProcessingResultNode {
          id
          autoMappedCount
          totalItemsCount
        }
        ... on AssignmentFeedbackNode {
          id
          specificAreasOfImprovement
          feedback
          lastUpdated
        }
        ... on AssignmentQuestionFeedbackNode {
          id
          specificAreasOfImprovement
          feedback
          lastUpdated
        }
        ... on QuizNode {
          id
        }
        ... on QuestionNode {
          id
          questionType
          educationLevel {
            id
            level
            yearGroups {
              id
              yearGroup
            }
          }
          yearGroup {
            id
            yearGroup
            educationLevel {
              id
              level
              yearGroups {
                id
                yearGroup
              }
            }
          }
          subject {
            id
            name
            parent {
              id
              name
            }
          }
          tags {
            id
            tag
          }
          questionText
          sourceText
          sourceImages {
            id
            fileUrl
            description
          }
          options {
            id
            text
            isCorrect
          }
          isPublished
          isComplete
          markScheme {
            id
            tags {
              id
              tag
            }
            modelAnswerGuidance
            objectives {
              id
              marks
              additionalInstructions
              assessmentObjective {
                id
                focusArea
                description
                identifier
                subject {
                  name
                }
              }
              levels {
                minMark
                maxMark
                levelCriteria
              }
            }
          }
        }
      }
    }
  }
`;

export const SEARCH_TAGS = gql`
  query ($educationLevel: ID, $subject: ID) {
    tags(educationLevel: $educationLevel, subject: $subject) {
      id
      tag
    }
  }
`;
export const GET_REGISTRATION_INFORMATION = gql`
  query {
    termsAndConditions {
      id
      preSignedUrl
    }
    homeSchool {
      id
      name
      addressLine1
      town
      subscriptionStatus
    }
  }
`;

export const FETCH_METRIC_OPTIONS = gql`
  query ($metricType: String!, $schoolMetrics: Boolean) {
    metricOptions(metricType: $metricType, schoolMetrics: $schoolMetrics)
  }
`;

export const FETCH_METRICS = gql`
  query (
    $metric: String!
    $metricType: String!
    $school: ID
    $subscriptionCategory: SubscriptionCategory
  ) {
    metrics(
      metric: $metric
      metricType: $metricType
      school: $school
      subscriptionCategory: $subscriptionCategory
    ) {
      name
      weeklyOnly
      data {
        date
        value
      }
      stats {
        ... on ChangeStatField {
          type
          name
          previous
          current
          successfulComparison
        }
        ... on OverallStat {
          type
          name
          total
          percentage
        }
        ... on TextBasedStat {
          type
          name
          text
        }
        ... on ProgressStatField {
          type
          name
          current
          target
          relativeTarget
        }
      }
    }
  }
`;

export const GET_TEMPORARY_UPLOAD_IMAGES = gql`
  query ($uploadToken: String!) {
    temporaryImages(uploadToken: $uploadToken) {
      id
      preSignedUrl
    }
  }
`;
